import React from 'react'
import { styled } from '@mui/system';
import CV from '../assets/cv.pdf';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import BusinessIcon from '@mui/icons-material/Business';
import Lottie from "lottie-react";
import codingAnimation from "../assets/dev.json"; 

const Container = styled('section')({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '50px'
})

const InfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '30px 0px 0px 0px'
})


const Subtitle5 = styled('h5')({
  fontSize: '12px',
  fontWeight: '500',
  color: 'var(--color-light)',
})

const Title = styled('h1')({
  fontSize: '48px',
  '@media (max-width: 1020px)' : {
    fontSize: '36px',
  }
})

const Subtitle4 = styled('h4')({
  fontSize: '18px',
  fontWeight: '600',
  color: 'var(--color-light)',
})

const ButtonContainer = styled('div')({
  display: 'flex',
  '@media (max-width: 480px)' : {
    flexDirection : 'column',
    marginTop: '10px',
  }
})

const Button = styled('a')((props) => ({
  backgroundColor: props.type === 'cv' ? 'transparent' : 'var(--color-primary)',
  color: props.type === 'cv' ? 'var(--color-primary)' : 'var(--color-bg)',
  fontWeight: '600',
  cursor: 'pointer',
  borderRadius: '5%',
  border: '1px solid var(--color-primary)',
  padding: '10px',
  margin: '50px 20px',
  transition: 'all 0.5s ease',
  '&:hover': {
    color: 'var(--color-bg)',
    backgroundColor: 'var(--color-white)',
    borderColor: 'transparent',
    transform: 'scale(1.05)',
    
  },
  '@media (max-width: 480px)' : {
    margin: '10px',
  }
}))

const Wrapper = styled('div')({
  display: 'flex',
  '@media (max-width: 1020px)' : {
    flexDirection : 'column',
    marginTop: '1px',
    gap : '1px'
  }
})

const Left = styled('div')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent : 'center'
})

const SocialContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  '@media (max-width: 1020px)' : {
    flexDirection : 'row',
  }
})

const SocialIcon = styled('div')({
  height: '40px',
  width: '40px',
  borderRadius: '50%',
  color: 'var(--color-primary)',
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '10px',
  '&:hover': {
    color: 'var(--color-white)',
    backgroundColor: 'var(--color-primary-variant)',
    transform: 'scale(1.1)',
    transition: 'all 0.5s ease',
  },
})

const Center = styled('div')({
  flex: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent : 'center',
})

const Right = styled('div')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent : 'center',
  '@media (max-width: 1020px)' : {
    display : 'none'
  }
})

const ScrollDown = styled('a')({
  cursor: 'pointer',
  textDecoration: 'none',
  color: 'var(--color-primary)',
  writingMode: 'vertical-rl',
  '&:hover': {
    color: 'var(--color-primary-variant)',
    transform: 'scale(1.1)',
    transition: 'all 0.5s ease',
  },
})


function Header() {
  
  return (
    <Container id='header'>
      <InfoContainer>
        <Subtitle5>Hello I'm</Subtitle5>
        <Title>Sonia Reffad</Title>
        <Subtitle4>Full-Stack Developer & AI Specialist</Subtitle4>
        
        <ButtonContainer>
          <Button href={CV} download type='cv'>Download CV</Button>
          <Button href='#contact' type='talk'>Let's Connect</Button>
        </ButtonContainer>
      </InfoContainer>
      <Wrapper>
        <Left>
          <SocialContainer>
            <a href='https://www.linkedin.com/in/sonia-reffad-56091916b/' target="_blank" rel="noreferrer">
              <SocialIcon>
                <LinkedInIcon />
              </SocialIcon>
            </a>
            <a href='https://github.com/soniareffadpro' target="_blank" rel="noreferrer">
              <SocialIcon>
                <GitHubIcon />
              </SocialIcon>
            </a>
            <a href='https://www.societe.com/societe/madame-sonia-reffad-989521521.html' target="_blank" rel="noreferrer">
              <SocialIcon>
                <BusinessIcon />
              </SocialIcon>
            </a>
          </SocialContainer>
        </Left>
        <Center>
          <Lottie 
            animationData={codingAnimation} 
            loop={true} 
            style={{ width: "80%", height: "80%"}}
          />
        </Center>
        <Right>
          <ScrollDown href='#footer'>Scroll down</ScrollDown>
        </Right>
      </Wrapper>
    </Container>
  )
}

export default Header